<template>
    <v-container fluid>
      <v-card>
        <v-toolbar color="secondary" flat dense>
          <v-toolbar-title>Update User Password</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn small text to="/users">
            <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <!-- editor -->
          <editor :docCreate="docCreate" :initial="dataItem" @data="save"></editor>
          <!-- end -->
        </v-card-text>
      </v-card>
  
      <!-- snackbar -->
      <snackbar ref="snackbar"></snackbar>
    </v-container>
  </template>
  
  <script>
  import Editor from "../_components/password-editor.vue";
  import { mapGetters } from "vuex";
  export default {
    components: {
      Editor,
    },
    computed: {
      ...mapGetters(["user"]),
    },
    data: () => ({
      dataItem: {},
      docCreate: false,
    }),
    watch: {
      "$route.params.id": {
        handler: "getUser",
        immediate: true,
      },
    },
    methods: {
      getUser(val) {
        const self = this;
        this.$store
          .dispatch("get", `/users/${val}`)
          .then((res) => {
            if (res.ResultCode == 1200) {
              self.dataItem = res.ResponseData;
              delete self.dataItem.password;
            } else {
              this.$refs.snackbar.show(res.msg, "red");
            }
          })
          .catch((err) => {
            this.$refs.snackbar.show(err, "red");
          });
      },
      save(data) {
        const id = this.dataItem.id;
        const url = `/users/${id}`;
        const self = this;
        this.$store
          .dispatch("put", { url, data })
          .then((res) => {
            if (res.ResultCode == 1200) {
              self.$store.commit("btnLoader", false);
              self.$router.push("/users");
            } else {
              self.$store.commit("btnLoader", false);
              this.$refs.snackbar.show(res.ResultDesc, "red");
            }
          })
          .catch((err) => {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(err, "red");
          });
      },
    },
  };
  </script>